import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {BaseResultComponent} from '../base-result/base-result.component';
import {WelfarePipeChartComponent} from '../charts/welfare-pipe-chart/welfare-pipe-chart.component';
import {PipeChartResult} from '../../../class/result/pipe-chart-result';
import {FamilyIncomeResult} from '../../../class/result/family-income-result';
import {NbWindowService} from '@nebular/theme';

@Component({
  selector: 'app-income-repartition',
  templateUrl: './income-repartition.component.html',
  styleUrls: ['./income-repartition.component.css']
})
export class IncomeRepartitionComponent extends BaseResultComponent implements OnInit {

  @Input()
  pipeResult: PipeChartResult;

  @Input()
  incomeResult: FamilyIncomeResult;

  total = 0;

  @ViewChild('annualIncomePipe')
  private annualIncomePipe: WelfarePipeChartComponent;

  constructor(windowService: NbWindowService) {
    super(windowService);
  }

  ngOnInit() {
  }

  onResultImpl(): void {
    super.onResultImpl();
    if (this.annualIncomePipe) {
      this.annualIncomePipe.pipeChartResult = this.pipeResult;
      this.annualIncomePipe.onResultImpl();
      this.computeTotal();
    }
  }

  private computeTotal() {
    if (this.incomeResult) {
      let totalIncome = this.incomeResult.totalIncome;

      this.pipeResult.series.forEach(obj => {
        if (obj.name !== 'Quota disponibile') {
          totalIncome -= obj.value;

          if (totalIncome < 0) {
            totalIncome = 0;
          }
        }
      });
      this.total = totalIncome;
    }

  }

}
